import { ref, computed } from 'vue'
import { urlUtils } from '../../utils'

// State variables
export const content = ref(null)
export const loading = ref(true)
export const linkPreview = ref({
  title: '',
  description: '',
  image: '',
})
export const isContentPublishing = ref(false)
export const commentCount = ref(0)

// Computed values factory functions
export const createPlatformName = (t) => computed(() => {
  if (content.value && content.value.platforms && content.value.platforms.length > 0 && content.value.platforms[0].platformName) {
    return content.value.platforms[0].platformName
  }
  return t('socialMedia.components.postInspector.socialPlatform')
})

export const createParsedHashtags = () => computed(() => {
  if (!content.value?.keywords) return []
  try {
    if (Array.isArray(content.value.hashtags)) {
      return content.value.hashtags
    }
    const keywords = JSON.parse(content.value.keywords)
    return keywords.map(keyword => keyword.startsWith('#') ? keyword : `#${keyword}`)
  } catch (e) {
    console.error('Error parsing hashtags', e)
    return []
  }
})

export const createIsImageLink = () => computed(() => {
  if (!content.value?.link) return false
  return urlUtils.isImageUrl(content.value.link)
})